import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardPage from "./DashboardPage";
import QuestionForm from "./QuestionForm";
import Userform from "./Userform";
import InstructionPage from "./InstructionPage";
import Preview from "./Preview";
import Thankyou from "./Thankyou";
import Responses from "./Responses";
import Formheader from "./Formheader";
import Centeredtab from "./Tabs";
import ResponsesPage from "./ResponsesPage";
import CreateForm from "./CreateForm";
function AuthenticatedRoutes({ photoURL, value, name }) {
  return (
    <Routes>
      <Route path="/" element={<DashboardPage photoURL={photoURL} value={value} />} />
      <Route path="/create-form" element={<CreateForm photoURL={photoURL} value={value} />} />
      <Route
        path="/form/:id"
        element={<QuestionForm photoURL={photoURL} value={value} />}
      />
      <Route
        path="/form/:id/responses"
        element={
          <>
            <Formheader photoURL={photoURL} value={value} />
            <Centeredtab />
            <Responses />
          </>
        }
      />
      <Route
        path="/form/:id/userform/submit"
        element={<Userform name={name} value={value} />}
      />
      <Route
        path="/form/:id/userform/isAnonymous"
        element={<Userform name={name} value={value} />}
      />
      <Route
        path="/form/:id/instructions/userform"
        element={<InstructionPage />}
      />
      <Route path="/form/:id/preview" element={<Preview />} />
      <Route path="/form/:id/thankyou" element={<Thankyou />} />
      <Route path="/responses" element={<ResponsesPage />} />
      {/* Add any additional routes for authenticated users here */}
    </Routes>
  );
}

export default AuthenticatedRoutes;
